import { DataHubService } from 'src/core/services/datahub';
import { ClickContentPageDeleteSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentPageDeleteSchema';
import { ClickContentPageDuplicateSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentPageDuplicateSchema';
import { ClickContentPageEditSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentPageEditSchema';
import { ClickContentPageMenuSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentPageMenuSchema';
import { ClickContentPageViewAsSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentPageViewAsSchema';
export const DispatchDatahubEvents = {
    clickContentPageMenu(pageType) {
        DataHubService.sendEvent({
            schema: new ClickContentPageMenuSchema({ pageType })
        });
    },
    clickContentPageEdit(pageType) {
        DataHubService.sendEvent({
            schema: new ClickContentPageEditSchema({
                pageType,
                componentName: 'CONTENT_CARD_EDIT_ACTION'
            })
        });
    },
    clickContentPageDuplicate(pageType) {
        DataHubService.sendEvent({
            schema: new ClickContentPageDuplicateSchema({ pageType })
        });
    },
    clickContentPageDelete(pageType) {
        DataHubService.sendEvent({
            schema: new ClickContentPageDeleteSchema({ pageType })
        });
    },
    clickContentPageViewAs(pageType) {
        DataHubService.sendEvent({
            schema: new ClickContentPageViewAsSchema({ pageType })
        });
    }
};
